'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsRestaurant = function MapsRestaurant(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z' })
  );
};
MapsRestaurant = (0, _pure2.default)(MapsRestaurant);
MapsRestaurant.displayName = 'MapsRestaurant';
MapsRestaurant.muiName = 'SvgIcon';

exports.default = MapsRestaurant;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/maps/restaurant.js
// module id = 3267
// module chunks = 0